import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TalktodoctorComponent } from './talktodoctor/talktodoctor.component';
import { ProvidercornerComponent } from './providercorner/providercorner.component';
import { ContactusComponent } from './contactus/contactus.component';
import { ServiceComponent } from './service/service.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_LOCALE,
  DateTimeAdapter,
  OWL_DATE_TIME_FORMATS,
} from 'ng-pick-datetime';
import { NgxPaginationModule } from 'ngx-pagination';
import { ChatComponent } from './video-chat/chat/chat.component';
import { VideoChatService } from './video-chat/services/videochat.service';
import { RequestappoinmentComponent } from './requestappoinment/requestappoinment.component';
import { TalktodoctorlandingComponent } from './talktodoctorlanding/talktodoctorlanding.component';
import { AuthErrorInterceptor } from './api-services/Auth/auth.error.interceptor';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AccountVerificationComponent } from './account-verification/account-verification.component';
import {
  NgxUiLoaderModule,
  NgxUiLoaderRouterModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
  NgxUiLoaderHttpModule,
} from 'ngx-ui-loader';
import { AvatarModule } from 'ngx-avatar';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { SchedulerModule } from 'angular-calendar-scheduler';
import { ConfirmAppointmentComponent } from './confirm-appointment/confirm-appointment.component';
import { MemberProfileComponent } from './member-profile/member-profile.component';
import { DoctorProfileComponent } from './doctor-profile/doctor-profile.component';
import { MemberAppointmentidComponent } from './member-appointmentid/member-appointmentid.component';
import { DoctorAppointmentidComponent } from './doctor-appointmentid/doctor-appointmentid.component';
import { MemberActiveAccountComponent } from './member-active-account/member-active-account.component';
import { ProductsComponent } from './products/products.component';
import { EmrRegistrationComponent } from './emr-registration/emr-registration.component';
import { BookServiceComponent } from './book-service/book-service.component';

import {
  KeycloakAngularModule,
  KeycloakBearerInterceptor,
  KeycloakService,
} from 'keycloak-angular';
import { AuthService } from './api-services/Auth/auth.service';
import { environment } from 'src/environments/environment';
import { AuthModule } from './api-services/keycloak/auth.module';
import { AuthGuard } from './api-services/keycloak/auth.guard';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DoctorRegistrationComponent } from './doctor-registration/doctor-registration.component';
import { TeamComponent } from './team/team.component';
import { AboutComponent } from './about/about.component';
import { MemberAppointmentComponent } from './member-appointment/member-appointment.component';
import { AppointmentByDoctorComponent } from './appointment-by-doctor/appointment-by-doctor.component';
import { DoctorAppointmentComponent } from './doctor-appointment/doctor-appointment.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { WellnessComponent } from './wellness/wellness.component';
import { RequestErrorComponent } from './request-error/request-error.component';
import { AhyushLoginComponent } from './ahyush-login/ahyush-login.component';
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#cfa639',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 65,
  fgsType: SPINNER.rectangleBouncePulseOut, // foreground spinner type
  blur: 10,
  hasProgressBar: false,
  minTime: 1,
};


@NgModule({
  declarations: [
    AppComponent,
    ProductsComponent,
    AboutComponent,
    TeamComponent,
    TalktodoctorComponent,
    ProvidercornerComponent,
    ContactusComponent,
    ServiceComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    DoctorRegistrationComponent,
    MemberAppointmentComponent,
    DoctorAppointmentComponent,
    AppointmentByDoctorComponent,
    ChatComponent,
    RequestappoinmentComponent,
    TalktodoctorlandingComponent,
    ForgotPasswordComponent,
    AccountVerificationComponent,
    ConfirmAppointmentComponent,
    MemberProfileComponent,
    DoctorProfileComponent,
    MemberAppointmentidComponent,
    DoctorAppointmentidComponent,
    MemberActiveAccountComponent,
    EmrRegistrationComponent,
    BookServiceComponent,
    PrivacyPolicyComponent,
    TermsAndConditionsComponent,
    WellnessComponent,
    RequestErrorComponent,
    AhyushLoginComponent,
  ],
  imports: [
    AuthModule,
    BrowserModule,
    KeycloakAngularModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    // NgxUiLoaderRouterModule.forRoot({ showForeground: true }),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      excludeRegexp: ['/keycloak1/getValidation', '/members/getMemberDetails'],
    }),
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    ModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AvatarModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    SchedulerModule.forRoot({
      locale: 'en',
      headerDateFormat: 'daysRange',
      logEnabled: true,
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
    VideoChatService,
    AuthGuard,
    { provide: LOCALE_ID, useValue: 'en-US' },
 
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
